export default {
  'consumption.co2': 'CO2 綜合排放值',
  'consumption.energy': '能耗',
  'consumption.fuel': '油耗',
  'footnotes.local':
    '本網站所標示之油耗測試係在實驗室內，依規定的行車型態於車體動力計上測得，實際道路行駛時，因天候、路況、載重、使用空調系統、駕駛習慣及車輛維修保養等因素影響，其於道路上每公升行駛的公里數應低於所標示之油耗測試值。其他標示之各項測試數據 ( 例如二氧化碳排放量或加速時間 ) 係在控制變因下所測得，實際駕駛時因受各項變因影響而會有所不同。',
  'footnotes.wltp':
    '本網站標示之WLTP測試範圍下所得之數據 (如加速度時間及純電行駛里程等) 係在實驗室內，依規定的行車型態測得。實際駕駛因受天候、路況、載重、駕駛習慣及維護保養等影響而會有所不同，僅供參考。本標示所示為原廠於歐盟測試數據，僅供參考。',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': '',
  'search.input.label': '請輸入關鍵字或訂製夢想車代碼',
  'search.result.buy-online': '',
  'search.results': '無相關搜尋結果| {count}項搜尋結果| {count}項搜尋結果',
  'search.results.count': '{count}項搜尋結果',
  'search.results.backup': '找不到完全符合此搜尋項目之結果，請查看相關頁面：',
  'search.results.none.summary': '找不到符合此搜尋項目之結果，請使用其他關鍵字搜尋。',
  'search.show-more': '顯示更多',
  'search.unavailable': '目前無法使用搜尋功能，請稍後再試。',
  'search.result.new': '新奇',

  'search.result.consumption': '消耗',

  'input.placeholder': '請輸入關鍵字或訂製夢想車代碼',

  'suggestions.all_search_results': '所有搜尋結果',
  'suggestions.all_search_results_for': '顯示所有結果',
  'suggestions.in': '在',

  all: '全部',
  UCOS: '二手車線上商店',
  PASSENGER_CARS: '轎車',
  VANS: '商旅車',
  NCOS: '',
  VIDEO: '影片',
  DEALER_LOCATOR: '經銷商搜尋',
  CONFIGURATOR: '訂製夢想車',
  TEST_DRIVE: '預約賞車',
  VEHICLE_SEARCH: '搜尋車款',
  COLLECT: 'Mercedes-Benz Collection 賓士精品',
  CONNECT: 'Mercedes Me Store 線上商店',

  'watch.video': '最近搜尋',
  'input.recently': '最近搜尋',
  'input.help.title': '您可尋找什麼資訊？',
  'input.help.text': '使用車款或車型名稱、訂製夢想車代碼、配備或其他產品資訊進行搜尋',

  'search.result.grid': '網格',
  'search.result.list': '列表',

  // Empty result
  'support.check': '請檢查是否存在拼寫錯誤，或使用其他字詞再試一次。',
  'support.no.results': '此搜尋字詞查無搜尋結果。',
  'support.no.results.term': '查無結果。',
  'support.chat': '找不到您想找的內容？請使用我們的。',
  'support.chat.with.us': '網上對話支援。',
};
